import React, { useEffect, useState } from "react";
import "./Accordion.scss";
import plus from "../../assets/plus.svg"
import minus from "../../assets/minus.svg"

import eye from "../../assets/eye.svg"
import DoubleRangeSlider from "../DoubleRangeSlider/DoubleRangeSlider";



const Accordion = ({ items, icon, isOpen, isSmall, layout, range, setRange, onapplyFilterclick, defRange, setDefRange, toggleDrawer }) => {
    const [activeIndex, setActiveIndex] = useState(isOpen ? 0 : null);
    useEffect(() => {
        if (setRange) {
            const filter = JSON.parse(localStorage.getItem("ECOM_CAT_PROD_DEF"))?.ProductFilter;
            const rangeVal = filter?.PriceRanges ? filter?.PriceRanges[0] || [] : []
            const min = rangeVal.find(item => item.Key === "MinPrice")?.Value
            const max = rangeVal.find(item => item.Key === "MaxPrice")?.Value
            setRange({ min: min, max: max })
            if (setDefRange) {
                setDefRange({ min: min, max: max })
            }
        }
    }, [items])
    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };
    const getPriceContent = (controlName) => {
        if (controlName === "Price" && range)

            return (
                defRange?.min != defRange?.max ?
                    <DoubleRangeSlider
                        min={defRange?.min}
                        max={defRange?.max}
                        minValue={range.min}
                        maxValue={range.max}
                        onChange={(newRange) => {
                            setRange(newRange)
                        }}
                    /> : <div className="value-display-container">
                        <span>£</span>

                        <span className='input-cont-range'
                        >
                            {defRange?.min}
                        </span> </div>
            )
    }
    const shouldShowAnyFilter = () => {
        const saved = localStorage.getItem("ECOM_CAT_PROD_DEF");
        const filter = saved ? JSON.parse(saved).ProductFilter ?? {} : {};

        return Object.values(items).some(({ ControlName }) => {
            if (!ControlName ||
                ControlName === "ProductCategory" ||
                ControlName === "ProductSubCategory") {
                return false;
            }

            return (ControlName === "Price" && (filter?.PriceRanges?.length ?? 0) > 0) && defRange?.min != defRange?.max ||
                (ControlName === "Weight" && !!filter?.Weight) ||
                (ControlName === "Brand" && (filter?.BrandIDs?.length ?? 0) > 0);
        });
    };

    const layout1 = () => {
        const filter = JSON.parse(localStorage.getItem("ECOM_CAT_PROD_DEF"))?.ProductFilter;

        return (<>
            {Object.keys(items).map((item, index) => {
                const controlName = items[item]?.ControlName;

                const isExcluded = controlName === "ProductCategory" || controlName === "ProductSubCategory";

                const isVisible =
                    (controlName === "Price" && filter?.PriceRanges?.length > 0) ||
                    (controlName === "Weight" && filter?.Weight) ||
                    (controlName === "Brand" && filter?.BrandIDs?.length > 0);

                const show = !isExcluded && isVisible;

                return (
                    controlName && show && (
                        <div className="accordion-item" key={index}>
                            <div
                                className={`accordion-header ${activeIndex === index ? "active" : ""}`}
                                onClick={() => toggleAccordion(index)}
                            >
                                <div className={isSmall ? "header-content-small" : "header-content"}>
                                    {icon && <img alt="" src={eye} />}
                                    {items[item]?.ControlLabel}
                                </div>
                                <div className="accordion-icon">
                                    <img alt="" src={activeIndex === index ? minus : plus} />
                                </div>
                            </div>
                            <div className={`accordion-content ${activeIndex === index ? "open" : ""}`}>
                                {getPriceContent(controlName)}
                            </div>
                        </div>
                    )
                );
            })}
        </>)
    };

    const layout2 = () => {
        return (
            items.map((item, index) => (
                <div className="accordion-item" key={index}>
                    <div
                        className={`accordion-header ${activeIndex === index ? "active" : ""
                            }`}
                        onClick={() => toggleAccordion(index)}
                    >
                        <div className={isSmall ? "header-content-small" : "header-content"}>
                            {icon && <img alt="" src={eye} />}
                            {item?.title}
                        </div>
                        <div className="accordion-icon">
                            <img alt="" src={activeIndex === index ? minus : plus} />
                        </div>
                    </div>
                    <div
                        className={`accordion-content ${activeIndex === index ? "open" : ""
                            }`}
                    >
                        {item?.content}
                    </div>
                </div>
            ))
        )
    }
    const getLayouts = () => {
        switch (layout) {
            case "layout1":
                return layout1()

            case "layout2":

                return layout2()

            default:
                return layout2()
        }

    }
    return (
        <>
            <div className="accordion">
                {getLayouts()}
            </div>
            {layout === "layout1" && shouldShowAnyFilter() &&
                <div className="filter-btn-ret" onClick={() => {
                    if (onapplyFilterclick) {
                        onapplyFilterclick()
                        if (toggleDrawer) {
                            toggleDrawer()
                        }
                    }
                }}>APPLY FILTER</div>}
        </>


    );
};

export default Accordion;
